import { render, staticRenderFns } from "./IconExclamationSolid.vue?vue&type=template&id=4752f432"
import script from "./IconExclamationSolid.vue?vue&type=script&lang=js"
export * from "./IconExclamationSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports